import {
  PAIN_HEIGHT,
  PAINS_GAP,
  PAINS_ROWS_MAX,
  PAINS_WIDTH,
  MORE_LABEL_MAX_WIDTH,
} from '../../const';

export const DEFAULT_ROWS_COUNT = 1;

const prepareVisibleItemStyles = (top, left) => ({
  top,
  left,
  visibility: 'visible',
});

const prepareHiddenItemStyles = () => ({
  top: 0,
  left: 0,
  visibility: 'hidden',
});

const prepareMoreStyles = (top, left) => ({
  top,
  left,
  maxWidth: MORE_LABEL_MAX_WIDTH,
});

export const calculateItemsProps = (elementsInfo) => {
  const result = {
    itemsStyles: [],
    rowsCount: DEFAULT_ROWS_COUNT,
    moreCount: 0,
    moreStyles: null,
  };

  const calculateTop = () => (PAIN_HEIGHT + PAINS_GAP) * (result.rowsCount - 1);
  let currentLeft = 0;

  elementsInfo.forEach((elementInfo, index) => {
    const currentWidth = elementInfo.width;

    // If item fits in the current row - place it here ...
    if (currentLeft + currentWidth <= PAINS_WIDTH) {
      result.itemsStyles[index] = prepareVisibleItemStyles(calculateTop(), currentLeft);
      currentLeft = currentLeft + currentWidth + PAINS_GAP;
    }

    // ... otherwise, check if we still can add rows, and place it as a first item there ...
    else if (result.rowsCount < PAINS_ROWS_MAX) {
      result.rowsCount += 1;

      result.itemsStyles[index] = prepareVisibleItemStyles(calculateTop(), 0);
      currentLeft = currentWidth + PAINS_GAP;
    }

    // ... if we can't add rows, then hide all other elements, but count them for "more" label
    else {
      result.itemsStyles[index] = prepareHiddenItemStyles();
      result.moreCount += 1;

      if (!result.moreStyles) {
        // If "more" label won't fit in what space we have left - hide previous "pain" as well
        if (currentLeft > PAINS_WIDTH - MORE_LABEL_MAX_WIDTH) {
          currentLeft = result.itemsStyles[index - 1].left;
          result.itemsStyles[index - 1] = prepareHiddenItemStyles();
          result.moreCount += 1;
        }

        result.moreStyles = prepareMoreStyles(calculateTop(), currentLeft);
        currentLeft = PAINS_WIDTH;
      }
    }
  });

  return result;
};

export const calculatePanelHeight = (rowsCount) =>
  PAIN_HEIGHT * rowsCount + PAINS_GAP * (rowsCount - 1);

export const prepareMorePainsTooltip = (pains, itemsStyles) => {
  const hiddenPains = pains.filter((pain, index) => {
    const itemStyle = itemsStyles[index];
    return itemStyle?.visibility === 'hidden';
  });

  return hiddenPains.map((name) => `\u2022 ${name}`).join('\n');
};
